import(/* webpackMode: "eager" */ "/var/www/InfinityV1/app/other_activities/[activity]/page.tsx");
